{
  "SLA": {
    "HEADER": "Service Level Agreements",
    "ADD_ACTION": "Додати SLA",
    "ADD_ACTION_LONG": "Створити нову SLA політику",
    "DESCRIPTION": "Угода про рівень послуг (SLAs) - це контракти, що визначають чіткі очікування між вашою командою та клієнтами. Вони встановлюють стандарти часу реагування та резолюції, створюючи рамки підзвітності та забезпечують послідовний, якісний досвід.",
    "LEARN_MORE": "Дізнатися більше про SLA",
    "LOADING": "Отримання SLAs",
    "PAYWALL": {
      "TITLE": "Оновіть, щоб створити SLA",
      "AVAILABLE_ON": "Функція SLA доступна тільки в планах Business та Enterprise.",
      "UPGRADE_PROMPT": "Оновіть ваш план, щоб отримати доступ до додаткових функцій, таких як управління командою, автоматизація, користувацькі атрибути та багато іншого.",
      "UPGRADE_NOW": "Оновити зараз",
      "CANCEL_ANYTIME": "Ви можете змінити або скасувати план у будь-який час"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Функція SLA доступна тільки в платних планах.",
      "UPGRADE_PROMPT": "Оновіться до платного плану для доступу до додаткових функцій, таких як аудиторські журнали, здатність агентів, тощо.",
      "ASK_ADMIN": "Будь ласка, зверніться до адміністратора для оновлення."
    },
    "LIST": {
      "404": "У цьому обліковому записі немає SLA.",
      "EMPTY": {
        "TITLE_1": "Enterprise P0",
        "DESC_1": "Питання, висунуті корпоративними клієнтами, які потребують негайної уваги.",
        "TITLE_2": "Enterprise P1",
        "DESC_2": "Питання, отримані підприємницькими клієнтами, потрібно швидко визнати."
      },
      "BUSINESS_HOURS_ON": "Увімкнено робочий час",
      "BUSINESS_HOURS_OFF": "Вимкнено робочий час",
      "RESPONSE_TYPES": {
        "FRT": "Час першої відповіді",
        "NRT": "Час наступної відповіді",
        "RT": "Час вирішення",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Назва SLA",
        "PLACEHOLDER": "Назва SLA",
        "REQUIRED_ERROR": "Необхідно вказати ім'я SLA",
        "MINIMUM_LENGTH_ERROR": "Необхідна мінімальна довжина 2",
        "VALID_ERROR": "Дозволено тільки букви, цифри, гіфен та підкреслення"
      },
      "DESCRIPTION": {
        "LABEL": "Опис",
        "PLACEHOLDER": "SLA для преміум клієнтів"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "Час першої відповіді",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "Час наступної відповіді",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "Час до вирішення",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "Робочий час",
        "PLACEHOLDER": "Тільки протягом робочих годин"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "Граничне значення має бути числом та більше нуля"
      },
      "EDIT": "Редагувати",
      "CREATE": "Створити",
      "DELETE": "Видалити",
      "CANCEL": "Скасувати"
    },
    "ADD": {
      "TITLE": "Додати SLA",
      "DESC": "Friendly promises for great service!",
      "API": {
        "SUCCESS_MESSAGE": "SLA успішно додано",
        "ERROR_MESSAGE": "Сталася помилка, будь ласка, спробуйте ще раз"
      }
    },
    "DELETE": {
      "TITLE": "Видалити SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA успішно видалено",
        "ERROR_MESSAGE": "Сталася помилка, будь ласка, спробуйте ще раз"
      },
      "CONFIRM": {
        "TITLE": "Підтвердження видалення",
        "MESSAGE": "Ви впевнені, що бажаєте видалити ",
        "YES": "Так, видалити ",
        "NO": "Ні, залишити "
      }
    },
    "EVENTS": {
      "TITLE": "SLA пропущено",
      "FRT": "Час першої відповіді",
      "NRT": "Час наступної відповіді",
      "RT": "Час вирішення",
      "SHOW_MORE": "{count} більше",
      "HIDE": "Приховати рядки {count}"
    }
  }
}
